import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { BusinessProfileProvider } from "./contexts/BusinessProfileContext";
import { BookingProvider } from "./contexts/BookingContext";
import { RealtimeProvider } from "./contexts/RealtimeContext";
import { ToastProvider } from "./contexts/ToastContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { MainLayout } from "./components/MainLayout";
import { SchedulerView } from "./components/SchedulerView";
import { RealtimeBookingSync } from "./components/RealtimeBookingSync";
import {
  Login,
  AgentRegister,
  AgentInvitationSetup,
  ForgotPassword,
  ResetPassword,
  VerifyEmail,
  BusinessRegister,
  BusinessProfileSetup,
} from "./components/Auth";
import { PaymentSuccess } from "./components/PaymentSuccess";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { AccountDeletion } from "./components/AccountDeletion";
import { BookBusiness } from "./components/BookBusiness";
import { ProductDeepLink } from "./components/ProductDeepLink";
import { TrainerAssociationConfirm } from "./components/TrainerAssociationConfirm";
import { BusinessParentChildConfirm } from "./components/BusinessParentChildConfirm";
import { BusinessProfilePage } from "./components/BusinessProfile";
import EmbedWidgetPage from "./components/EmbedWidget/EmbedWidgetPage";

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
      <AuthProvider>
        <BusinessProfileProvider>
        <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/register/agent" element={<AgentRegister />} />
            <Route path="/register/business" element={<BusinessRegister />} />
            <Route path="/invitation/:token" element={<AgentInvitationSetup />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<AccountDeletion />} />
            <Route path="/book/:businessId" element={<BookBusiness />} />
            <Route path="/product/:productId" element={<ProductDeepLink />} />
            <Route path="/trainer-association/:token" element={<TrainerAssociationConfirm />} />
            <Route path="/business-association/:token" element={<BusinessParentChildConfirm />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <RealtimeProvider>
                    <BookingProvider>
                      <RealtimeBookingSync />
                      <MainLayout>
                        <SchedulerView />
                      </MainLayout>
                    </BookingProvider>
                  </RealtimeProvider>
                </ProtectedRoute>
              }
            />

            {/* Business Profile Setup (after registration) */}
            <Route
              path="/setup/business-profile"
              element={
                <ProtectedRoute skipProfileCheck>
                  <BusinessProfileSetup />
                </ProtectedRoute>
              }
            />

            {/* Business Profile Settings */}
            <Route
              path="/settings/business-profile"
              element={
                <ProtectedRoute>
                  <RealtimeProvider>
                    <BookingProvider>
                      <MainLayout>
                        <BusinessProfilePage />
                      </MainLayout>
                    </BookingProvider>
                  </RealtimeProvider>
                </ProtectedRoute>
              }
            />

            {/* Embed Widget Settings */}
            <Route
              path="/settings/widget"
              element={
                <ProtectedRoute>
                  <RealtimeProvider>
                    <BookingProvider>
                      <MainLayout>
                        <EmbedWidgetPage />
                      </MainLayout>
                    </BookingProvider>
                  </RealtimeProvider>
                </ProtectedRoute>
              }
            />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BusinessProfileProvider>
      </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
